export default [
    {
        path: 'settings',
        component: require('@/layouts/content/settings').default,
        name: 'admin.settings',
        redirect: to => {
            return {
                name: 'admin.assets.accounts.index'
            }
        },
        children: [
            /** Product categories */
            {
                path: 'categories',
                name: 'admin.products.categories.index',
                component: require('@/views/admin/products/categories/index').default,
                meta: {
                    auth: {
                        roles: ['manage-product-categories']
                    }
                }
            },
            {
                path: 'categories/create',
                name: 'admin.products.categories.create',
                component: require('@/views/admin/products/categories/form').default,
                props: true,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-product-categories']
                    }
                }
            },
            {
                path: 'categories/:id',
                name: 'admin.products.categories.edit',
                component: require('@/views/admin/products/categories/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-product-categories']
                    }
                }
            },

            {
                path: 'crm',
                name: 'admin.crm.settings',
                component: require('@/views/admin/crm/settings').default,
                meta: {
                    auth: {
                        roles: ['manage-settings']
                    }
                }
            },

            {
                path: 'branches',
                name: 'admin.branches.index',
                component: require('@/views/admin/branches/index').default,
                meta: {
                    auth: {
                        roles: ['manage-branches']
                    }
                }
            },
            {
                path: 'branches/create',
                name: 'admin.branches.create',
                component: require('@/views/admin/branches/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-branches']
                    }
                }
            },
            {
                path: 'branches/:id',
                name: 'admin.branches.edit',
                component: require('@/views/admin/branches/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-branches']
                    }
                }
            },
            /** Accounts */
            {
                path: 'accounts',
                name: 'admin.assets.accounts.index',
                component: require('@/views/admin/assets/accounts/index').default,
                meta: {
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },
            {
                path: 'accounts/create',
                name: 'admin.assets.accounts.create',
                component: require('@/views/admin/assets/accounts/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },
            {
                path: 'accounts/:id',
                name: 'admin.assets.accounts.edit',
                component: require('@/views/admin/assets/accounts/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },

            /** Funds */
            {
                path: 'funds',
                name: 'admin.assets.funds.index',
                component: require('@/views/admin/assets/funds/index').default,
                meta: {
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },
            {
                path: 'funds/create',
                name: 'admin.assets.funds.create',
                component: require('@/views/admin/assets/funds/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },
            {
                path: 'funds/:id',
                name: 'admin.assets.funds.edit',
                component: require('@/views/admin/assets/funds/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-assets']
                    }
                }
            },
        ]
    }
]